import { giftReceiptSchema } from "@redotech/redo-model/gift-receipt/gift-receipt";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum GetGiftReceiptsErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  NOT_FOUND = "NOT FOUND",
  COULD_NOT_PARSE = "COULD NOT PARSE",
}

export const getGiftReceipts = {
  name: "getGiftReceipts" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: z.object({
    giftReceipts: z.array(giftReceiptSchema),
    orderNumber: z.string(),
    orderDate: z.date(),
  }),
};
